import { useEffect, useState } from 'react'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import type { AppDispatch, RootState } from 'stores'

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export const useIsSp = (breakpoint: number) => {
  const getMatches = () =>
    typeof window !== 'undefined' &&
    window.matchMedia(`(max-width: ${breakpoint}px)`).matches
  const [isSp, setIsSp] = useState(getMatches)

  useEffect(() => {
    const mediaQuery = window.matchMedia(`(max-width: ${breakpoint}px)`)
    const onChange = () => setIsSp(mediaQuery.matches)

    onChange()
    mediaQuery.addEventListener?.('change', onChange)
    return () => mediaQuery.removeEventListener?.('change', onChange)
  }, [breakpoint])

  return isSp
}
